export default class GlbSource {
    constructor({ url, requestInit }) {
        this.url = url;
        this.requestInit = requestInit;
    }
}
//# sourceMappingURL=GlbSource.js.map